module.exports = __webpack_public_path__ + "img/mo-fm-1.e62592c7.png";